import "react-app-polyfill/ie11";
import React, { useState, useCallback } from "react";
import { createRoot } from "react-dom/client";
import Root from "./client_customizations/containers/Root/Root";
import { BrowserRouter as Router, useLocation } from "react-router-dom";
import { IntlProvider } from "react-intl";
import * as serviceWorker from "./serviceWorker";
import "./utils/polyfills";
import MESSAGES from "./context/translations/messages";

const RootWrapper = (props) => {
     const location = useLocation();
     return <Root {...props} location={location} />;
};

const App = () => {
     const [language, setLanguage] = useState("EN");

     const changeLanguage = useCallback((lang) => {
          setLanguage(lang);
     }, []);

     return (
          <IntlProvider locale={language} messages={MESSAGES[language]}>
               <Router>
                    <RootWrapper language={language} changeLanguage={changeLanguage} />
               </Router>
          </IntlProvider>
     );
};

const rootElement = document.getElementById("root");
createRoot(rootElement).render(<App />);

serviceWorker.unregister();
